export default "__VITE_PUBLIC_ASSET__d24a5cbe__"